import { formattedFlyerOptions } from "@apac/travelers";

// The major Canadian carriers surface first for RBC; the rest keep their
// existing alphabetical order.
export const PRIORITY_AIRLINE_CODES = [
  "AC", // Air Canada - Aeroplan
  "WS", // WestJet - WestJet Rewards
  "PD", // Porter Airlines - VIPorter
];

export const sortFlyerOptions = (
  options: typeof formattedFlyerOptions
): typeof formattedFlyerOptions => [
  ...PRIORITY_AIRLINE_CODES.flatMap(
    (code) => options.find((option) => option.value === code) ?? []
  ),
  ...options.filter((option) => !PRIORITY_AIRLINE_CODES.includes(option.value)),
];

export const rbcFlyerOptions = sortFlyerOptions(formattedFlyerOptions);
